<template>
  <div>
    <h1>AuthView</h1>
    <p>Login</p>
  </div>
</template>